import React from 'react';
import { useLoggedIn } from 'bv-hooks';
import CenterContentView from './center_content_view';

export default () => {
  const loggedIn = useLoggedIn();

  return (
    <CenterContentView
      loggedIn={loggedIn}
    />
  );
};
